import { Badge, Button, Collapse } from '@themesberg/react-bootstrap';
import React, { useState } from 'react'
import { deleteTicket, updateStatusTicket } from '../../../../controller/api/__classic__/ticketStorage';
import ImagePreview from '../../ticket/sub-screen/image-preview/ImagePreview';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const PairTicketRow = (props) => {
  const { rIndex, cookies, onRefresh, pairGroup, resultStatus, onEditTicket } = props;
  const { last5Numbers, representative, tickets } = pairGroup;

  const [expanded, setExpanded] = useState(false);
  const [showImagePreview, setShowImagePreview] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewTitle, setPreviewTitle] = useState('');

  const displayNumbers = `* ${(last5Numbers || "").split('').join(' ')}`;
  const totalAmount = representative.amount;
  const images = representative.images;
  const status = representative.status;

  const handleDeleteAll = async () => {
    const isConfirmed = window.confirm(`Xóa tất cả ${tickets.length} vé cặp *${last5Numbers}?`);
    if (!isConfirmed) return;

    for (const ticket of tickets) {
      await deleteTicket(cookies.lottmekong, ticket.id);
    }
    onRefresh && onRefresh();
  };

  const handleToggleStatus = async (newStatus) => {
    for (const ticket of tickets) {
      await updateStatusTicket(cookies.lottmekong, ticket.id, newStatus);
    }
    onRefresh && onRefresh();
  };

  const handleDeleteSingle = async (ticketId) => {
    const isConfirmed = window.confirm('Xóa vé này?');
    if (!isConfirmed) return;
    
    await deleteTicket(cookies.lottmekong, ticketId);
    onRefresh && onRefresh();
  };

  const handleToggleSingleStatus = async (ticketId, newStatus) => {
    await updateStatusTicket(cookies.lottmekong, ticketId, newStatus);
    onRefresh && onRefresh();
  };

  const openImagePreview = (img, title) => {
    setPreviewImage(img);
    setPreviewTitle(title);
    setShowImagePreview(true);
  };

  return (
    <>
      <tr 
        style={{ backgroundColor: '#fff8e1', cursor: 'pointer' }}
        onClick={() => setExpanded(!expanded)}
      >
        <td className='text-center fw-bold'>
          <FontAwesomeIcon 
            icon={expanded ? faChevronDown : faChevronRight} 
            style={{ marginRight: 8 }}
          />
          {rIndex + 1}
        </td>
        <td className='text-center'>
          <Badge bg="warning" text="dark">Cặp nguyên</Badge>
          <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>
            {tickets.length} vé
          </div>
        </td>
        <td style={{ fontSize: 25 }} className='text-center text-danger fw-bold'>
          {displayNumbers}
        </td>
        <td className='text-center fw-bold'>{totalAmount}</td>
        <td className='text-center'>
          {images ? (
            <img 
              src={images && typeof images === 'string' && images.startsWith('http') ? images : `data:image/jpeg;base64,${images}`} 
              alt="Ticket" 
              style={{ maxWidth: '60px', maxHeight: '60px', cursor: 'pointer' }} 
              onClick={(e) => {
                e.stopPropagation();
                openImagePreview(images, `Vé cặp *${last5Numbers}`);
              }}
            />
          ) : '-'}
        </td>
        <td onClick={(e) => e.stopPropagation()}>
          {status === 0 &&
            <Button variant='warning' size="sm" onClick={handleDeleteAll}>
              Xóa tất cả
            </Button>
          }
          &nbsp;&nbsp;
          {(status === 1) &&
            <Button variant='warning' size="sm" onClick={() => handleToggleStatus(6)}>
              Tạm ngưng tất cả
            </Button>
          }
          &nbsp;&nbsp;
          {(status === 6) &&
            <Button variant='warning' size="sm" onClick={() => handleToggleStatus(1)}>
              Hoạt động tất cả
            </Button>
          }
        </td>
      </tr>

      {expanded && tickets.map((ticket, idx) => (
        <tr key={ticket.id} style={{ backgroundColor: '#fffef5' }}>
          <td className='text-center' style={{ paddingLeft: 30, color: '#888', fontSize: 13 }}>
            └ {idx + 1}
          </td>
          <td className='text-center'>
            <Badge bg="secondary" style={{ fontSize: 10 }}>Con</Badge>
          </td>
          <td style={{ fontSize: 20 }} className='text-center text-primary fw-bold'>
            {(ticket.numbers || "").split('').join(' ')}
          </td>
          <td className='text-center'>{ticket.amount}</td>
          <td className='text-center'>
            {ticket.images ? (
              <img 
                src={ticket.images && typeof ticket.images === 'string' && ticket.images.startsWith('http') ? ticket.images : `data:image/jpeg;base64,${ticket.images}`} 
                alt="Ticket" 
                style={{ maxWidth: '50px', maxHeight: '50px', cursor: 'pointer' }} 
                onClick={() => openImagePreview(ticket.images, `Vé số ${ticket.numbers}`)}
              />
            ) : (
              <span style={{ color: '#999', fontSize: 12 }}>Chưa có hình</span>
            )}
          </td>
          <td>
            {ticket.status === 0 &&
              <Button variant='outline-danger' size="sm" onClick={() => handleDeleteSingle(ticket.id)}>
                Xóa
              </Button>
            }
            &nbsp;&nbsp;
            {(ticket.status === 0 || ticket.status === 6) &&
              <Button variant='outline-primary' size="sm" onClick={() => onEditTicket && onEditTicket(ticket)}>
                Sửa
              </Button>
            }
            &nbsp;&nbsp;
            {(ticket.status === 1) &&
              <Button variant='outline-warning' size="sm" onClick={() => handleToggleSingleStatus(ticket.id, 6)}>
                Tạm ngưng
              </Button>
            }
            &nbsp;&nbsp;
            {(ticket.status === 6) &&
              <Button variant='outline-success' size="sm" onClick={() => handleToggleSingleStatus(ticket.id, 1)}>
                Hoạt động
              </Button>
            }
          </td>
        </tr>
      ))}

      <ImagePreview 
        show={showImagePreview} 
        onHide={() => setShowImagePreview(false)} 
        image={previewImage} 
        title={previewTitle}
      />
    </>
  );
};

export default React.memo(PairTicketRow)
